// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../../../themes/theme-capri-prod/assets/js/" + ({"7":"restaurant","177":"home","231":"checkout","637":"order"}[chunkId] || chunkId) + "." + {"7":"99f39256","177":"2111ad4c","231":"a6bcd29b","637":"47e72869","686":"c631bf12","688":"f62a0570"}[chunkId] + ".js";
};